import { styled, TextField } from "@mui/material";

const ChatInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    // A11Y FIX: restore a clearly visible focus indicator on the input — but
    // only for keyboard users. MUI's .Mui-focused is set on every focus,
    // including a plain mouse click, which put a border around the field for
    // everyone. :focus-visible leaves the mouse path untouched. The sibling
    // selector targets the fieldset MUI renders after the input; `textarea`
    // covers the multiline case this field actually uses.
    "& input:focus-visible ~ fieldset, & textarea:focus-visible ~ fieldset": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}));

export default ChatInput;
